import { TextField } from '@material-ui/core';
import React from 'react';

/**
 * @param {import('@material-ui/core').TextFieldProps} props
 */
export default function DateFilter(props) {
  return (
    <TextField
      variant="outlined"
      color="primary"
      type="date"
      size="small"
      fullWidth
      InputLabelProps={{
        shrink: true,
      }}
      {...props}
    />
  );
}